import { render, staticRenderFns } from "./MissionSnsButtonParts.vue?vue&type=template&id=b2752b6c&scoped=true"
import script from "./MissionSnsButtonParts.vue?vue&type=script&lang=ts"
export * from "./MissionSnsButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./MissionSnsButtonParts.vue?vue&type=style&index=0&id=b2752b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2752b6c",
  null
  
)

export default component.exports